export default __webpack_public_path__ + "static/media/洪鼎詠.ce73158d.jpg";